export const toNumber = (value: unknown): number | null => {
  if (value == null) return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export const toDominanceFlag = (value: unknown): boolean => {
  if (typeof value === 'boolean') return value
  return String(value).toLowerCase() === 'true'
}
